export const painPoints: string[] = [
  'Hours spent searching for drills and training ideas',
  'Repeating the same exercises because they are easy to remember',
  'Striking, clinch and grappling sessions that feel disconnected',
  'Difficulty organizing beginner, intermediate and advanced athletes',
  'No clear progression between one session and the next',
  'Too much time planning and not enough time coaching',
  'Athletes learning isolated techniques instead of understanding complete MMA transitions',
  'Walking into the gym with ideas instead of a complete structure',
]

export const planningLoop: string[] = [
  'You search.',
  'You organize.',
  'You adapt.',
  'You connect techniques.',
  'You decide progressions.',
]
